import styled from "styled-components";
import theme from "../../theme/theme";
import CircularProgressBar from "../Base/CircularProgressBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;

  > svg {
    min-width: 70px;
  }

  .infoWrapper {
    margin: 0 25px;
    display: flex;
    flex-direction: column;

    @media (max-width: 480px) {
      display: block;
      margin: 5px 0px;
    }
  }

  .title {
    font-weight: bold;
  }

  .modelAssetsDescription {
    margin-top: 20px;
    font-size: 20px;
    letter-spacing: 0px;
    color: #3a3a3d;
    max-width: 350px;

    @media (max-width: 480px) {
      display: block;
      margin: 5px 0px;
    }
  }

  button {
    color: ${theme.colors.white};
    margin-left: auto;
    position: relative;
  }

  @media (max-width: 480px) {
    display: block;
    text-align: center;
  }
`;

const ProgressBar = styled(CircularProgressBar)`
  min-width: 70px;
`;

const Link = styled.a`
  white-space: nowrap;
  margin-left: auto;
  background-color: #bcc2c7;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  padding: 10px 15px;
  color: ${theme.colors.white};
  font-weight: bold;
  font-size: 20px;
  box-sizing: border-box;
  height: auto;

  @media (max-width: 480px) {
    display: block;
  }
`;

const RecommendedPortfolioItem = ({
  percent,
  modelAssetsDescription,
  pdfUrl,
  title = "Title",
}) => {
  return (
    <Wrapper>
      <ProgressBar progress={percent} />
      <div className="infoWrapper">
        <span className="title">{title}</span>
        {/* <span className="modelAssetsDescription">{modelAssetsDescription}</span> */}
      </div>
      <Link
        className="sm-onlyIcon"
        href={pdfUrl}
        target="_blank"
        rel="noreferrer"
        download
      >
        <FontAwesomeIcon icon={faChartBar} />{" "}
        {/* <BarChartIcon width={35} /> */}
        View Model
      </Link>
    </Wrapper>
  );
};

export default RecommendedPortfolioItem;
